import { render, staticRenderFns } from "./CreateStmt.vue?vue&type=template&id=b095bb1c&"
import script from "./CreateStmt.vue?vue&type=script&lang=js&"
export * from "./CreateStmt.vue?vue&type=script&lang=js&"
import style0 from "./CreateStmt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports